import DemoSpaceMembers from "../DemoSpaceMembers";
import DemoSpaceTimeline from "./index";

export const demoSpaceRoutes = [
  {
    path: "/spaces/demo/:id/members",
    exact: true,
    component: DemoSpaceMembers,
  },
  {
    path: "/spaces/demo/:id",
    exact: true,
    component: DemoSpaceTimeline,
  },
];
